// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"2f884c9b","377":"8287e559","391":"65b4581e","584":"40dc283c","660":"1f19bf96","918":"cfb60fea"}[chunkId] + ".chunk.js";
};